/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
document.addEventListener("DOMContentLoaded", () => {
  init();
});

function init() {
  handleImageWithTextScrollButton();
  handleDescriptionMoreInformation();
}

function handleImageWithTextScrollButton() {
  const scrollButton = [...document.querySelectorAll('[js-product="productScrollButton"]')];

  scrollButton.forEach((button) => {
    button.addEventListener('click', () => {
      const productPage = document.querySelector('.product__page');

      if (productPage) {
        productPage.scrollIntoView();
        return;
      }

      const featuredProductSection = document.querySelector('.section--featured-product');

      if (featuredProductSection) {
        featuredProductSection.scrollIntoView();
      }
    });
  })
}

function handleDescriptionMoreInformation() {
  const moreInformationButton = document.querySelector('[js-product-description="moreInformation"]');

  if (!moreInformationButton) {
    return;
  }

  moreInformationButton.addEventListener('click', () => {
    // const mainTag = moreInformationButton.closest('#MainContent');

    const accordionGroupSection = document.querySelector('.accordion-group');

    if (!accordionGroupSection) {
      return;
    }

    const sectionTop = accordionGroupSection.getBoundingClientRect().top;
  
    const topHeight = sectionTop + window.pageYOffset - 40;
  
    window.scrollTo({
      top: topHeight, 
      behavior: 'smooth'
    });
    
    // if (!mainTag) {
    //   return;
    // }

    // const nextShopifySection = [...mainTag.querySelectorAll('.shopify-section')];

    // if (!nextShopifySection[2]) {
    //   return;
    // }

    // const sectionTop = nextShopifySection[2].getBoundingClientRect().top;

    // const topHeight = sectionTop + window.pageYOffset - 40;

    // window.scrollTo({
    //   top: topHeight, 
    //   behavior: 'smooth'
    // });
  });
}
